import React from 'react';
import { trackMixpanelEvent } from 'utils/utilMethods';
import { MixpanelEventName } from 'utils/constants';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Theme from 'theme';
import { Avatar } from '@mui/material';
import { ReactComponent as AddPatients } from 'assets/AddPatients.svg';
import { ReactComponent as MedicationHistory } from 'assets/MedicationHistory.svg';
import { ReactComponent as InformPatient } from 'assets/InformPatient.svg';

const ICON_SIZE_MD = 106;
const ICON_SIZE_SM = 80;
const ICON_SIZE_XS = 64;

const stepData = [
  { icon: AddPatients, label: 'Add patients' },
  { icon: MedicationHistory, label: 'Get medication history' },
  { icon: InformPatient, label: 'Inform patient care' },
];

function StepModalDefaultContent() {
  React.useEffect(() => {
    trackMixpanelEvent(MixpanelEventName.ONBOARDING_SAVE_TIME_WITH_HEADLAMP_MODAL_VIEWED);
  }, []);

  return (
    <>
      {/* Stepper icons with dashed line */}
      <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 4.5, maxWidth: 700, width: '100%' }} gap={{ xs: 1, sm: 0 }}>
        {stepData.map((item, idx) => (
          <React.Fragment key={item.label}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} flex={1}>
              <Avatar
                sx={{
                  bgcolor: '#E1F5FE',
                  color: '#3A7EC1',
                  width: { xs: ICON_SIZE_XS, sm: ICON_SIZE_SM, md: ICON_SIZE_MD },
                  height: { xs: ICON_SIZE_XS, sm: ICON_SIZE_SM, md: ICON_SIZE_MD },
                  mb: 1,
                  fontSize: 20,
                  boxShadow: '0 2px 8px 0 rgba(58,126,193,0.08)',
                }}
              >
                {item.icon && React.createElement(item.icon, {
                  width: '50%',
                  height: '50%',
                  preserveAspectRatio: 'none',
                })}
              </Avatar>
              <Typography variant='subtitle2' color={Theme.custom.colors.lightTextPrimary} sx={{ mt: 2, fontSize: 14 }}>
                {item.label}
              </Typography>
            </Box>
            {idx < stepData.length - 1 && (
              <Box
                sx={{
                  width: 100,
                  height: 2,
                  borderBottom: '2px dashed #D2D2D2',
                  mx: 1,
                }}
                display={{ xs: 'none', sm: 'block' }}
                mt={{ sm: `calc(${ICON_SIZE_SM}px / 2)`, md: `calc(${ICON_SIZE_MD}px / 2)` }}
              />
            )}
          </React.Fragment>
        ))}
      </Box>
      <Typography
        variant='h6'
        fontWeight={500}
        mb={1}
        sx={{ fontSize: 20, letterSpacing: 0.15 }}
        color={Theme.custom.colors.lightTextPrimary}
      >
        Save time with Headlamp
      </Typography>
      <Typography
        variant='body1'
        color={Theme.custom.colors.lightTextPrimary}
        mb={4}
        sx={{ maxWidth: 420, mx: 'auto', lineHeight: 1.7 }}
      >
        Headlamp gives clinicians back
        {' '}
        <Box component='span' fontWeight={700} color={Theme.custom.colors.lightTextPrimary} sx={{ fontSize: 16, display: 'inline' }}>
          2+ hours each day
        </Box>
        <br />
        {' '}
        to focus on what matters most.
      </Typography>
    </>
  );
}

export default StepModalDefaultContent;
